import { Radio } from "@mantine/core";

export const BaseRadio = Radio;
